import { render, staticRenderFns } from "./Belt.vue?vue&type=template&id=0992e52c&scoped=true"
import script from "./Belt.vue?vue&type=script&lang=js"
export * from "./Belt.vue?vue&type=script&lang=js"
import style0 from "./Belt.vue?vue&type=style&index=0&id=0992e52c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992e52c",
  null
  
)

export default component.exports